
<template>
  <div class="alloy-property-analytics">
    <v-row no-gutters class="ma-0">
      <v-col cols="12" md="7" class="pa-2 pt-7 pr-3 pl-3">
        <div class="chartBox pa-1 pl-3 ">
          <AnalyticsChart :internalSeriesData="internalSeriesData"></AnalyticsChart>
        </div>
      </v-col>
      <v-col cols="12" md="5" class="pa-2 mt-6">
        <div class="filterBox" data-tour="predix-benchmark-against">
          <div class="filterBox__title mb-5">Benchmark Against:</div>
          <v-select
            v-model="selectedBenchmarkIds"
            :items="benchmarkSelectItems"
            item-text="name"
            item-value="id"
            chips
            clearable
            placeholder="Saved or standard alloy"
            multiple
            outlined
            dense
            hide-details
            :class="['filterBox__select', { 'filterBox__select--has-chips': hasSelectedAlloys }]"
            :menu-props="benchmarkMenuProps"
          >
            <template #prepend-inner>
              <i class="fa-solid fa-cube filterBox__fa-icon" aria-hidden="true"></i>
            </template>
            <template v-slot:selection="{ item }">
              <v-chip
                small
                close
                class="filterBox__chip"
                :class="{ 'filterBox__chip--fav': item.isFavorite }"
                @click:close="remove(item && item.id != null ? item.id : item)"
              >
                <v-icon v-if="item.isFavorite" x-small left>mdi-star</v-icon>
                {{ item.name }}
              </v-chip>
            </template>
          </v-select>
        </div>
      </v-col>
    </v-row>
    
    <!-- <v-row>
      <v-col cols="8" id="chart">

        <apexchart type="bar" :height="height" :options="chartOptions" :series="series"></apexchart>
      </v-col>
    </v-row> -->
  </div>
</template>
<script>
// import VueApexCharts from 'vue-apexcharts'
import { gradient } from '@/utils/color'
import { getData} from '@/api/user/dataset'
import AnalyticsChart from '@/components/Predix/AnalyticsChart.vue'
 

export default {
  name: 'AlloyPropertyAnalytics',
   components: {
          AnalyticsChart
    },  
    props:{
      seriesData:[],
      standardAlloys:[],
      favoriteAlloys: {
        type: Array,
        default: () => [],
      },
      groups:[],
      package_id: {
        type: Number,
        default:0
      },
      standardDatasetName: {
        type: String,
        default:''
      },
      standardDatasetId:{
        type: Number,
        default:0
      },
      prpName: {
        type: String,
        default: ''
      }
    },
    watch: {
      selectedBenchmarkIds(newList, oldList){
        if(newList.length > oldList.length)
        {
          const newlyAddedId = newList[newList.length - 1]
          this.addBenchmarkAlloy(newlyAddedId)
        } else {
          const diff = oldList.filter(item => newList.indexOf(item) == -1)
          diff.forEach((id) => this.removeBenchmarkSeries(id))
          this.loadChart()
        }
      }
    },
    computed: {
      benchmarkSelectItems(){
        const items = [{ header: "My Saved Alloys" }]
        const favorites = this.favoriteAlloys || []
        if (!favorites.length) {
          items.push({
            name: "No saved alloys yet",
            disabled: true,
          })
        } else {
          favorites.forEach((fav) => {
            items.push({
              id: this.favoriteSelectId(fav.id),
              name: this.formatSavedAlloyDisplay(fav.name),
              isFavorite: true,
            })
          })
        }
        items.push({ divider: true })
        items.push({ header: "Standard Alloys" })
        ;(this.standardAlloys || []).forEach((alloy) => {
          items.push({
            id: alloy.id,
            name: alloy.name,
            isFavorite: false,
          })
        })
        return items
      },
      benchmarkMenuProps() {
        return {
          bottom: true,
          offsetY: true,
          nudgeBottom: 4,
          contentClass: "filterBox__menu",
        };
      },
      hasSelectedAlloys() {
        return this.selectedBenchmarkIds.length > 0;
      },
    },
    methods: {
      favoriteSelectId(id) {
        return `fav::${id}`
      },
      isFavoriteSelectId(id) {
        return String(id || "").startsWith("fav::")
      },
      favoriteIdFromSelectId(id) {
        return String(id || "").slice(5)
      },
      formatSavedAlloyDisplay(name) {
        const raw = String(name || "")
        const match = raw.match(/^[FS]([1-9]\d{0,6})$/i)
        if (!match) return raw
        return `S ${String(match[1]).padStart(6, "0")}`
      },
      addBenchmarkAlloy(selectId) {
        if (this.isFavoriteSelectId(selectId)) {
          this.addSavedAlloy(selectId)
          return
        }
        const newAlloy = (this.standardAlloys || []).find(
          (item) => String(item.id) === String(selectId)
        )
        if (!newAlloy) return
        const _this = this
        getData(this.package_id, this.standardDatasetId, [ {"f0": newAlloy.id}],this.groups, function(res){
          if (!_this.selectedBenchmarkIds.includes(selectId) && !_this.selectedBenchmarkIds.includes(newAlloy.id)) return
          const al = res.result && res.result[0] ? res.result[0][_this.prpName] : 0
          _this.internalSeriesData.push({
            name: newAlloy.name,
            value: al,
            type: "STANDARD",
            selectId,
          })
          _this.loadChart()
        })
      },
      addSavedAlloy(selectId) {
        const favId = this.favoriteIdFromSelectId(selectId)
        const fav = (this.favoriteAlloys || []).find((item) => String(item.id) === String(favId))
        if (!fav) return
        const prop = ((fav.items || []).find((item) =>
          item && item.kind === "property" && String(item.name) === String(this.prpName)
        ))
        const n = Number(prop && prop.value)
        this.internalSeriesData.push({
          name: this.formatSavedAlloyDisplay(fav.name),
          value: Number.isFinite(n) ? n : 0,
          type: "STANDARD",
          selectId,
        })
        this.loadChart()
      },
      removeBenchmarkSeries(selectId) {
        const idx = this.internalSeriesData.findIndex(
          (item) => item.selectId === selectId || item.name === selectId
        )
        if (idx > -1) this.internalSeriesData.splice(idx, 1)
      },
      onReset(){
        this.selectedBenchmarkIds=[]
        this.internalSeriesData = this.internalSeriesData.filter(item => item.type !== 'STANDARD')
        this.loadChart()
       },
      loadChart(){
      const dt = this.internalSeriesData.sort((a,b) => { 
        if(a.value < b.value) {
          return -1
        } 
        if(a.value > b.value) {
          return 1
        } 
        return 0
        })
      this.series[0].data = dt.map(item => item.value)
      this.chartOptions.xaxis.categories = dt.map(item => item.name)
      var m = this.chartOptions.xaxis.categories.length
      this.height = m * 50
      const start = '#96ead7'
      const end = '#165e4e'
      const stdStart = '#5591ca'
      const stdEnd = '#163b5e'
      this.chartOptions.colors = []
      for (var i = 0; i< m; i++){
        if ( dt[i].type === 'PRP' ){
          this.chartOptions.colors.push('#ff9800')
        } else if ( dt[i].type === 'STANDARD' ){
          this.chartOptions.colors.push(gradient(i/m, stdStart, stdEnd))
        }else {
          this.chartOptions.colors.push(gradient(i/m, start, end))
        }
      }

    },         
      remove (id) {
        this.selectedBenchmarkIds = this.selectedBenchmarkIds.filter((it) => it !== id)
      },
    },
    data: () => ({
    selectedBenchmarkIds:[],
    internalSeriesData:[],
    height: 200,
    series: [{
            data: []
          }],
    chartOptions: {
      chart: {
        type: 'bar',
      },
      plotOptions: {
        bar: {
          barHeight: '90%',
          distributed: true,
          horizontal: true,
          dataLabels: {
            position: 'bottom'
          },
        }
      },
      colors: [],
      dataLabels: {
        enabled: true,
        textAnchor: 'end',
        style: {
          colors: ['#444']
        },
        formatter: function (val) {
          if(val % 1 === 0 ){
            return  val
            // return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
          } else{
            return  val.toPrecision(6)
            // return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val.toPrecision(6)
          }
        },
        offsetX: 0,
        dropShadow: {
          enabled: true,
          color: '#fff',
          top: 0,
          left: 0,
          blur: 1,
          opacity: 1
        }
      },
      stroke: {
        width: 1,
        colors: ['#fff']
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        labels: {
          show: false
        }
      },
      title: {
          text: '',
          align: 'center',
          floating: true
      },
      tooltip: {
        theme: 'dark',
        x: {
          show: false
        },
        y: {
          title: {
            formatter: function () {
              return ''
            }
          }
        }
      }
    }
  })
    ,
    
    created(){
      this.chartOptions.title.text = this.prpName 
      this.internalSeriesData =  this.seriesData
      this.loadChart()

    }
}
</script>
<style scoped lang="scss">
/* Avoid nested scroll in expanded table rows: no 100% height trap, no row negative-margin overflow */
.alloy-property-analytics {
  overflow: visible;
  max-height: none;
  width: 100%;
  min-width: 0;
}

.filterBox {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  padding: 0.75rem 0.75rem 1.125rem;
  border-radius: var(--radius-lg);
  min-height: 0;
}

.filterBox__title {
  font-size: var(--text-sm);
  font-weight: 600;
  font-family: var(--font-inter), var(--font-sans);
  letter-spacing: 0.01em;
}

.filterBox__fa-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  min-width: 1rem;
  font-size: 0.875rem;
  line-height: 1;
  flex-shrink: 0;
  pointer-events: none;
}

::v-deep .filterBox__select.v-text-field--outlined {
  margin: 0;
  padding: 0;

  > .v-input__control {
    align-items: center;
  }

  > .v-input__control > .v-input__slot {
    min-height: 2.5rem !important;
    display: flex !important;
    align-items: center !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  &.v-input--is-label-active > .v-input__control > .v-input__slot {
    min-height: 2.5rem !important;
    height: auto !important;
    align-items: center !important;
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }

  &.filterBox__select--has-chips .v-label {
    display: none !important;
  }

  &.filterBox__select--has-chips fieldset legend {
    max-width: 0.01px !important;
    width: 0.01px !important;
    padding: 0 !important;
    overflow: hidden;
  }

  &.filterBox__select--has-chips fieldset legend span {
    display: none !important;
    padding: 0 !important;
  }

  fieldset {
    border-radius: var(--radius-lg) !important;
  }

  &.v-input--is-focused fieldset {
    border-width: 1px !important;
  }

  .v-label {
    font-size: var(--text-sm);
    font-family: var(--font-inter), var(--font-sans);
  }

  &.v-text-field--outlined.v-input--dense:not(.v-input--is-label-active) .v-label {
    top: 50% !important;
    transform: translateY(-50%) !important;
  }

  &.v-text-field--outlined.v-input--dense.v-input--is-label-active:not(.filterBox__select--has-chips) .v-label {
    top: 0.625rem !important;
    transform: translateY(0) scale(0.75) !important;
    transform-origin: left top;
  }

  .v-select__slot {
    width: auto !important;
    flex: 1 1 auto !important;
    min-width: 0 !important;
    max-width: none !important;
    align-items: center;
  }

  .v-select__selections {
    gap: 0.25rem;
    min-height: 1.5rem;
    align-items: center;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    flex-wrap: wrap;
  }

  .v-select__selections input,
  .v-select__selections input:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: transparent !important;
    min-width: 0 !important;
    padding: 0 !important;
    --tw-ring-shadow: 0 0 #0000 !important;
    --tw-ring-offset-shadow: 0 0 #0000 !important;
  }

  .v-input__prepend-inner,
  .v-input__append-inner {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-self: center !important;
  }

  &.v-input--is-label-active .v-input__prepend-inner,
  &.v-input--is-label-active .v-input__append-inner {
    align-self: center !important;
  }

  .v-input__prepend-inner {
    position: relative;
    z-index: 1;
    flex: 0 0 auto !important;
    flex-shrink: 0 !important;
    margin-right: 0 !important;
    padding-right: 0.5rem !important;
    display: inline-flex !important;
    align-items: center !important;
    width: auto !important;
    min-width: 1rem !important;
    overflow: visible !important;
  }
}

::v-deep .filterBox__chip.v-chip {
  font-size: 0.6875rem;
  font-weight: 600;
  height: 1.375rem;
}

::v-deep .filterBox__chip--fav.v-chip {
  background-color: color-mix(in srgb, var(--v-primary-base) 18%, var(--color-white)) !important;
}
</style>

<style lang="scss">
/*
  Theme colors — unscoped (match AnalyticsChart / CastingExploreResult):
  - Light: .v-application.theme--light
  - Dark: html.dark AND .v-application.theme--dark
*/

/* —— filterBox card —— */
.v-application.theme--light .alloy-property-analytics .filterBox {
  border: 1px solid var(--color-gray-100);
  background-color: var(--color-gray-50);
}

.v-application.theme--light .alloy-property-analytics .filterBox__title {
  color: var(--color-gray-700);
}

.v-application.theme--light .alloy-property-analytics .filterBox__fa-icon {
  color: var(--color-gray-500);
}

html.dark .alloy-property-analytics .filterBox,
.v-application.theme--dark .alloy-property-analytics .filterBox {
  border: 1px solid color-mix(in srgb, var(--color-gray-700) 60%, transparent);
  background-color: var(--color-gray-800);
}

html.dark .alloy-property-analytics .filterBox__title,
.v-application.theme--dark .alloy-property-analytics .filterBox__title {
  color: var(--color-gray-300);
}

html.dark .alloy-property-analytics .filterBox__fa-icon,
.v-application.theme--dark .alloy-property-analytics .filterBox__fa-icon {
  color: var(--color-gray-400);
}

/* —— select field —— */
.alloy-property-analytics .filterBox__select.filterBox__select--has-chips fieldset legend {
  max-width: 0 !important;
  width: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
}

.alloy-property-analytics .filterBox__select.filterBox__select--has-chips fieldset legend span {
  display: none !important;
  padding: 0 !important;
}

.v-application.theme--light .alloy-property-analytics .filterBox__select.v-text-field--outlined > .v-input__control > .v-input__slot {
  background-color: var(--color-white) !important;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.v-application.theme--light .alloy-property-analytics .filterBox__select.v-text-field--outlined fieldset {
  border-color: var(--color-gray-200) !important;
  /* Paint the fill on the fieldset (the bordered box) so the background always
     matches the border rectangle exactly, regardless of the label-notch offset. */
  background-color: var(--color-white) !important;
}

.v-application.theme--light .alloy-property-analytics .filterBox__select.v-text-field--outlined:hover fieldset,
.v-application.theme--light .alloy-property-analytics .filterBox__select.v-text-field--outlined.v-input--is-focused fieldset {
  border-color: var(--color-gray-300) !important;
}

.v-application.theme--light .alloy-property-analytics .filterBox__select .v-label {
  color: var(--color-gray-500) !important;
}

.v-application.theme--light .alloy-property-analytics .filterBox__select .v-input__append-inner .v-icon {
  color: var(--color-gray-500) !important;
}

.v-application.theme--light .alloy-property-analytics .filterBox__select .v-select__selections,
.v-application.theme--light .alloy-property-analytics .filterBox__select .v-select__selection {
  color: var(--color-gray-800) !important;
}

.v-application.theme--light .alloy-property-analytics .filterBox__chip.v-chip {
  background-color: color-mix(in srgb, var(--v-primary-base) 12%, var(--color-white)) !important;
  color: var(--color-gray-800) !important;
}

html.dark .alloy-property-analytics .filterBox__select.v-text-field--outlined > .v-input__control > .v-input__slot,
.v-application.theme--dark .alloy-property-analytics .filterBox__select.v-text-field--outlined > .v-input__control > .v-input__slot {
  background-color: color-mix(in srgb, var(--color-gray-900) 45%, var(--color-gray-800)) !important;
  box-shadow: none;
}

html.dark .alloy-property-analytics .filterBox__select.v-text-field--outlined fieldset,
.v-application.theme--dark .alloy-property-analytics .filterBox__select.v-text-field--outlined fieldset {
  border-color: color-mix(in srgb, var(--color-gray-600) 70%, transparent) !important;
  /* Paint the fill on the fieldset (the bordered box) so the background always
     matches the border rectangle exactly, regardless of the label-notch offset. */
  background-color: color-mix(in srgb, var(--color-gray-900) 45%, var(--color-gray-800)) !important;
}

html.dark .alloy-property-analytics .filterBox__select.v-text-field--outlined:hover fieldset,
.v-application.theme--dark .alloy-property-analytics .filterBox__select.v-text-field--outlined:hover fieldset,
html.dark .alloy-property-analytics .filterBox__select.v-text-field--outlined.v-input--is-focused fieldset,
.v-application.theme--dark .alloy-property-analytics .filterBox__select.v-text-field--outlined.v-input--is-focused fieldset {
  border-color: var(--color-gray-500) !important;
}

html.dark .alloy-property-analytics .filterBox__select .v-label,
.v-application.theme--dark .alloy-property-analytics .filterBox__select .v-label {
  color: var(--color-gray-400) !important;
}

html.dark .alloy-property-analytics .filterBox__select .v-input__append-inner .v-icon,
.v-application.theme--dark .alloy-property-analytics .filterBox__select .v-input__append-inner .v-icon {
  color: var(--color-gray-400) !important;
}

html.dark .alloy-property-analytics .filterBox__select .v-select__selections,
.v-application.theme--dark .alloy-property-analytics .filterBox__select .v-select__selections,
html.dark .alloy-property-analytics .filterBox__select .v-select__selection,
.v-application.theme--dark .alloy-property-analytics .filterBox__select .v-select__selection {
  color: var(--color-gray-100) !important;
}

html.dark .alloy-property-analytics .filterBox__chip.v-chip,
.v-application.theme--dark .alloy-property-analytics .filterBox__chip.v-chip {
  background-color: color-mix(in srgb, var(--v-primary-base) 22%, var(--color-gray-800)) !important;
  color: var(--color-gray-100) !important;
}

html.dark .alloy-property-analytics .filterBox__chip--fav.v-chip,
.v-application.theme--dark .alloy-property-analytics .filterBox__chip--fav.v-chip {
  background-color: color-mix(in srgb, var(--v-primary-base) 30%, var(--color-gray-800)) !important;
}

html.dark .alloy-property-analytics .filterBox__chip.v-chip .v-chip__close,
.v-application.theme--dark .alloy-property-analytics .filterBox__chip.v-chip .v-chip__close {
  color: var(--color-gray-300) !important;
}

/* —— dropdown menu (teleported) —— */
.filterBox__menu .v-list-item--disabled .v-list-item__action {
  display: none !important;
}
.v-application.theme--light .filterBox__menu {
  margin-top: 0.25rem !important;
  border: 1px solid var(--color-gray-200) !important;
  border-radius: var(--radius-lg) !important;
  background-color: var(--color-white) !important;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
  overflow: hidden;
}

.v-application.theme--light .filterBox__menu .v-list {
  padding: 0.25rem 0 !important;
  background: transparent !important;
}

.v-application.theme--light .filterBox__menu .v-list-item {
  min-height: 2.25rem !important;
  padding-inline: 0.75rem !important;
  font-size: var(--text-sm) !important;
  font-family: var(--font-inter), var(--font-sans) !important;
  color: var(--color-gray-800) !important;
}

.v-application.theme--light .filterBox__menu .v-list-item::before {
  border-radius: var(--radius-md);
}

.v-application.theme--light .filterBox__menu .v-list-item:hover {
  background-color: var(--color-gray-50) !important;
}

.v-application.theme--light .filterBox__menu .v-list-item--active {
  background-color: color-mix(in srgb, var(--v-primary-base) 10%, var(--color-white)) !important;
  color: var(--color-gray-900) !important;
}

.v-application.theme--light .filterBox__menu .v-list-item__title {
  font-size: var(--text-sm) !important;
  font-weight: 500;
}

html.dark .filterBox__menu,
.v-application.theme--dark .filterBox__menu,
html.dark .filterBox__menu.theme--light,
.v-application.theme--dark .filterBox__menu.theme--light {
  margin-top: 0.25rem !important;
  border: 1px solid color-mix(in srgb, var(--color-gray-600) 70%, transparent) !important;
  border-radius: var(--radius-lg) !important;
  background-color: var(--color-gray-800) !important;
  box-shadow: 0 4px 12px rgb(0 0 0 / 0.45) !important;
  overflow: hidden;
}

html.dark .filterBox__menu .v-list,
.v-application.theme--dark .filterBox__menu .v-list,
html.dark .filterBox__menu.theme--light .v-list,
.v-application.theme--dark .filterBox__menu.theme--light .v-list {
  padding: 0.25rem 0 !important;
  background: transparent !important;
}

html.dark .filterBox__menu .v-list-item,
.v-application.theme--dark .filterBox__menu .v-list-item,
html.dark .filterBox__menu.theme--light .v-list-item,
.v-application.theme--dark .filterBox__menu.theme--light .v-list-item {
  min-height: 2.25rem !important;
  padding-inline: 0.75rem !important;
  font-size: var(--text-sm) !important;
  font-family: var(--font-inter), var(--font-sans) !important;
  color: var(--color-gray-200) !important;
}

html.dark .filterBox__menu .v-list-item::before,
.v-application.theme--dark .filterBox__menu .v-list-item::before,
html.dark .filterBox__menu.theme--light .v-list-item::before,
.v-application.theme--dark .filterBox__menu.theme--light .v-list-item::before {
  border-radius: var(--radius-md);
}

html.dark .filterBox__menu .v-list-item:hover,
.v-application.theme--dark .filterBox__menu .v-list-item:hover,
html.dark .filterBox__menu.theme--light .v-list-item:hover,
.v-application.theme--dark .filterBox__menu.theme--light .v-list-item:hover {
  background-color: color-mix(in srgb, var(--color-gray-700) 45%, transparent) !important;
}

html.dark .filterBox__menu .v-list-item--active,
.v-application.theme--dark .filterBox__menu .v-list-item--active,
html.dark .filterBox__menu.theme--light .v-list-item--active,
.v-application.theme--dark .filterBox__menu.theme--light .v-list-item--active {
  background-color: color-mix(in srgb, var(--v-primary-base) 22%, var(--color-gray-800)) !important;
  color: var(--color-gray-100) !important;
}

html.dark .filterBox__menu .v-list-item__title,
.v-application.theme--dark .filterBox__menu .v-list-item__title,
html.dark .filterBox__menu.theme--light .v-list-item__title,
.v-application.theme--dark .filterBox__menu.theme--light .v-list-item__title {
  font-size: var(--text-sm) !important;
  font-weight: 500;
  color: inherit !important;
}

/* Vuetify may still attach theme--light on teleported menus in dark app */
html.dark .alloy-property-analytics .filterBox__select.v-text-field--outlined.theme--light > .v-input__control > .v-input__slot,
.v-application.theme--dark .alloy-property-analytics .filterBox__select.v-text-field--outlined.theme--light > .v-input__control > .v-input__slot {
  background-color: color-mix(in srgb, var(--color-gray-900) 45%, var(--color-gray-800)) !important;
}

html.dark .alloy-property-analytics .filterBox__select.v-text-field--outlined.theme--light fieldset,
.v-application.theme--dark .alloy-property-analytics .filterBox__select.v-text-field--outlined.theme--light fieldset {
  border-color: color-mix(in srgb, var(--color-gray-600) 70%, transparent) !important;
  background-color: color-mix(in srgb, var(--color-gray-900) 45%, var(--color-gray-800)) !important;
}
</style>